import { Component } from '@angular/core';

@Component({
  selector: 'app-estetica-main-page',
  templateUrl: './estetica-main-page.component.html',
})
export class EsteticaMainPageComponent {

}
